// extracted by css-extract-rspack-plugin
export default {"cls1":"Accordion-cls1_gqG","cls2":"Accordion-cls2_yUF Accordion-cls1_gqG"};